/* eslint-disable @typescript-eslint/no-explicit-any */
/* 
  this,
  ocrMode,
  this.__ocrType,
  this.__inProgressStep,
  this.__topUI,
  'top',
  this.__options.useTopUITextMsg,
  this.__options.useCaptureUI,
  this.__options.usePreviewUI,
  recognizedImage
 */
interface I_OCR_Progress {
  ocrMode: string;
  ocrType: string;
  inProgress: string;
  customUI: HTMLElement;
  uiPosition: string;
  useTextMsg: boolean;
  useCaptureUI: boolean;
  usePreviewUI: boolean;
  recognizedImage: string | null;
}
type T_OCR_ProgressArgs = [string, string, string, HTMLElement, string, boolean, boolean, boolean, string | null];
export const mergeFromResponse = (response: T_OCR_ProgressArgs): I_OCR_Progress => {
  const ocrMode = response[0];
  const ocrType = response[1];
  const inProgress = response[2];
  const customUI = response[3];
  const uiPosition = response[4];
  const useTextMsg = response[5];
  const useCaptureUI = response[6];
  const usePreviewUI = response[7];
  const recognizedImage = response[8];

  return {
    ocrMode,
    ocrType,
    inProgress,
    customUI,
    uiPosition,
    useTextMsg,
    useCaptureUI,
    usePreviewUI,
    recognizedImage,
  };
};
export const getProgress = (ocr: any, data: I_OCR_Progress) => {
  const isCreditCard = data.ocrType.indexOf("credit") > -1;
  const cardTypeString = isCreditCard ? "신용카드" : "신분증";

  const result = { message: "", process: "" };

  switch (data.inProgress) {
    case ocr.IN_PROGRESS.NOT_READY:
      result.process = "loading";
      break;
    case ocr.IN_PROGRESS.READY:
    case ocr.IN_PROGRESS.CARD_DETECT_SUCCESS:
      result.message = `<p class="bottom-ui-description">신분증이 영역 안에 꽉 차도록</p>
              <p class="bottom-ui-description">위치시키면 자동으로 촬영됩니다.</p>`;
      result.process = "capture";
      break;
    case ocr.IN_PROGRESS.CARD_DETECT_FAILED:
    case ocr.IN_PROGRESS.MANUAL_CAPTURE_SUCCESS:
    case ocr.IN_PROGRESS.MANUAL_CAPTURE_FAILED:
    case ocr.IN_PROGRESS.OCR_RECOGNIZED:
      result.message = `<p class="bottom-ui-description">신분증이 영역 안에 꽉 차도록</p>
              <p class="bottom-ui-description">위치시키면 자동으로 촬영됩니다.</p>`;
      break;
    case ocr.IN_PROGRESS.OCR_RECOGNIZED_WITH_SSA:
      result.message = `<p class="bottom-ui-description">신분증을 확인하고 있어요.</p>`;
      result.process = "preview";
      break;
    case ocr.IN_PROGRESS.OCR_SUCCESS_WITH_SSA:
      result.message = `<p class="bottom-ui-description">신분증을 확인하고 있어요.</p>`;
      result.process = "preview";
      break;
    case ocr.IN_PROGRESS.OCR_FAILED:
      result.message = `${cardTypeString} 인식에 실패하였습니다. 다시 시도해주세요.`;
      break;
    default:
      break;
  }

  return result;
};

export const getPreviewProcess = (ocr: any, data: I_OCR_Progress) => {
  const isCreditCard = data.ocrType.indexOf("credit") > -1;
  const cardType = isCreditCard ? "신용카드" : "신분증";
  switch (data.inProgress) {
    case ocr.IN_PROGRESS.MANUAL_CAPTURE_SUCCESS:
      return `<br/>${cardType} 정보 인식(OCR) 중 ...<br/>`;
    case ocr.IN_PROGRESS.MANUAL_CAPTURE_FAILED:
      return `<br/>${cardType} 감지 실패! 다시 촬영해주세요.<br/>(잠시 후 자동으로 알림이 닫힙니다.)<br/>`;
    case ocr.IN_PROGRESS.OCR_RECOGNIZED_WITH_SSA:
      return `<br/>${cardType} 사본(도용) 여부 판별 중...<br/>`;
    default:
      return "";
  }
};

const getLoadingMarkup = (uiPosition: string, loading: boolean, fillColor: string) => {
  return (
    `` +
    `<svg xmlns='http://www.w3.org/2000/svg' id='${uiPosition}-ui-loading' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin: auto; background: none; display: ${
      loading ? "block" : "none"
    }; shape-rendering: auto;' width='32px' height='32px' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'>\n` +
    `  <circle cx='84' cy='50' r='10' fill='${fillColor}'>\n` +
    `    <animate attributeName='r' repeatCount='indefinite' dur='0.5555555555555556s' calcMode='spline' keyTimes='0;1' values='10;0' keySplines='0 0.5 0.5 1' begin='0s'></animate>\n` +
    `    <animate attributeName='fill' repeatCount='indefinite' dur='2.2222222222222223s' calcMode='discrete' keyTimes='0;0.25;0.5;0.75;1' values='#86868600;#86868600;#86868600;#86868600;#86868600' begin='0s'></animate>\n` +
    `  </circle>` +
    `  <circle cx='16' cy='50' r='10' fill='${fillColor}'>\n` +
    `    <animate attributeName='r' repeatCount='indefinite' dur='2.2222222222222223s' calcMode='spline' keyTimes='0;0.25;0.5;0.75;1' values='0;0;10;10;10' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' begin='0s'></animate>\n` +
    `    <animate attributeName='cx' repeatCount='indefinite' dur='2.2222222222222223s' calcMode='spline' keyTimes='0;0.25;0.5;0.75;1' values='16;16;16;50;84' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' begin='0s'></animate>\n` +
    `  </circle>` +
    `  <circle cx='50' cy='50' r='10' fill='${fillColor}'>\n` +
    `    <animate attributeName='r' repeatCount='indefinite' dur='2.2222222222222223s' calcMode='spline' keyTimes='0;0.25;0.5;0.75;1' values='0;0;10;10;10' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' begin='-0.5555555555555556s'></animate>\n` +
    `    <animate attributeName='cx' repeatCount='indefinite' dur='2.2222222222222223s' calcMode='spline' keyTimes='0;0.25;0.5;0.75;1' values='16;16;16;50;84' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' begin='-0.5555555555555556s'></animate>\n` +
    `  </circle>` +
    `  <circle cx='84' cy='50' r='10' fill='${fillColor}'>\n` +
    `    <animate attributeName='r' repeatCount='indefinite' dur='2.2222222222222223s' calcMode='spline' keyTimes='0;0.25;0.5;0.75;1' values='0;0;10;10;10' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' begin='-1.1111111111111112s'></animate>\n` +
    `    <animate attributeName='cx' repeatCount='indefinite' dur='2.2222222222222223s' calcMode='spline' keyTimes='0;0.25;0.5;0.75;1' values='16;16;16;50;84' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' begin='-1.1111111111111112s'></animate>\n` +
    `  </circle>` +
    `  <circle cx='16' cy='50' r='10' fill='${fillColor}'>\n` +
    `    <animate attributeName='r' repeatCount='indefinite' dur='2.2222222222222223s' calcMode='spline' keyTimes='0;0.25;0.5;0.75;1' values='0;0;10;10;10' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' begin='-1.6666666666666665s'></animate>\n` +
    `    <animate attributeName='cx' repeatCount='indefinite' dur='2.2222222222222223s' calcMode='spline' keyTimes='0;0.25;0.5;0.75;1' values='16;16;16;50;84' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' begin='-1.6666666666666665s'></animate>\n` +
    `  </circle>\n` +
    `</svg>`
  );
};

export const renderProgress = (data: {
  message: string;
  customUI: HTMLElement;
  uiPosition: string;
  loading: boolean;
}) => {
  const el_text = data.customUI.querySelector(`#${data.uiPosition}-ui-text-msg`);
  const el_loading = data.customUI.querySelector(`#${data.uiPosition}-ui-loading`);

  if (el_text) el_text.innerHTML = data.message;
  if (el_loading) el_loading.innerHTML = `${getLoadingMarkup(data.uiPosition, data.loading, "#000038")}`;
};
